/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpMoveRequest
 */
export interface FuelUpMoveRequest {
    /**
     * Type of move to make
     * @type {string}
     * @memberof FuelUpMoveRequest
     */
    moveType: FuelUpMoveRequestMoveTypeEnum;
    /**
     * Action to take on landed space (default activate)
     * @type {string}
     * @memberof FuelUpMoveRequest
     */
    spaceAction?: FuelUpMoveRequestSpaceActionEnum;
}


/**
 * @export
 */
export const FuelUpMoveRequestMoveTypeEnum = {
    roll: 'roll',
    single: 'single',
    double: 'double'
} as const;
export type FuelUpMoveRequestMoveTypeEnum = typeof FuelUpMoveRequestMoveTypeEnum[keyof typeof FuelUpMoveRequestMoveTypeEnum];

/**
 * @export
 */
export const FuelUpMoveRequestSpaceActionEnum = {
    activate: 'activate',
    skip: 'skip'
} as const;
export type FuelUpMoveRequestSpaceActionEnum = typeof FuelUpMoveRequestSpaceActionEnum[keyof typeof FuelUpMoveRequestSpaceActionEnum];


/**
 * Check if a given object implements the FuelUpMoveRequest interface.
 */
export function instanceOfFuelUpMoveRequest(value: object): value is FuelUpMoveRequest {
    if (!('moveType' in value) || value['moveType'] === undefined) return false;
    return true;
}

export function FuelUpMoveRequestFromJSON(json: any): FuelUpMoveRequest {
    return FuelUpMoveRequestFromJSONTyped(json, false);
}

export function FuelUpMoveRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpMoveRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'moveType': json['moveType'],
        'spaceAction': json['spaceAction'] == null ? undefined : json['spaceAction'],
    };
}

export function FuelUpMoveRequestToJSON(json: any): FuelUpMoveRequest {
    return FuelUpMoveRequestToJSONTyped(json, false);
}

export function FuelUpMoveRequestToJSONTyped(value?: FuelUpMoveRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'moveType': value['moveType'],
        'spaceAction': value['spaceAction'],
    };
}

